import React, { useEffect, useRef } from 'react';
import TextField from '@mui/material/TextField';
import { InputStyles } from './StyleOverrides';
import './EliasInput.scss';
import {
  EliasInputProps,
  handleInputChange,
  handleInputFocus,
} from './elias-input-utils';

function EliasBooleanInput({
  value,
  onChange,
  id,
  ariaLabel,
  placeholder = undefined,
}: EliasInputProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  // Prevent the mouse wheel from incrementing/decrementing the input value
  useEffect(() => {
    const handleWheel = (event: WheelEvent) => {
      event.preventDefault();
    };

    const inputElement = inputRef.current;
    if (inputElement) {
      inputElement.addEventListener('wheel', handleWheel, { passive: false });
    }

    return () => {
      if (inputElement) {
        inputElement.removeEventListener('wheel', handleWheel);
      }
    };
  }, []);

  const isInputValid = value === '' || value === '1' || value === '0';

  return (
    <TextField
      inputRef={ inputRef }
      onFocus={handleInputFocus}
      inputProps={{
        inputMode: 'numeric',
        pattern: '[0-9]*',
        'aria-label': ariaLabel,
        'data-testid': `${id}-value-input`,
      }}
      size="small"
      type="number"
      value={value}
      placeholder={placeholder}
      onChange={(event) => handleInputChange(event, onChange)}
      sx={InputStyles}
      error={!isInputValid}
    />
  );
}

export default EliasBooleanInput;
